import cashBookInstance from '../../cashBook/instance'

const initialBalanceForCashBook = (data) => {
	return cashBookInstance.post('/cash-book/primary-balance', data)
}
export default initialBalanceForCashBook
